<template>
	<transition appear name="fast-fade">
		<div class="site-search-results-ko-layer" v-if="visible" @click="visible = false"></div>
	</transition>
	<transition appear name="fast-fade">
		<div class="site-search-results" v-if="visible">

      <block-site-search></block-site-search>

			<template v-if="!search_term">
				<div class="site-search-results__quick-links">
					<div class="site-search-results__quick-links-title">Quick links</div>
          <ul class="site-search-results__quick-links-list">
            <li>
              <a href="/search/jobs" class="chevron">Discover opportunities</a>
            </li>
            <li>
              <a href="/search/collections" class="chevron">Collections</a>
            </li>
            <li>
              <a href="/search/saved" class="chevron">Your saved content</a>
            </li>
            <li>
              <a href="/escape100" class="chevron">Escape 100 best companies: {{escapeYear}}</a>
            </li>
          </ul>
				</div>

				<div class="site-search-results__quick-links" v-if="recent.length > 0">
          <div class="site-search-results__quick-links-title">
					  Recently searched for <span role="button" @click="clearRecentSearches">Clear</span>
          </div>
          <ul class="site-search-results__quick-links-list">
            <template v-for="(term,t) in recent_searches" :key="`recent_${t}`">
              <li v-if="term !== ''">
                <a href="#" @click.prevent="pickRecentSearch(term)" class="magnifying-glass">{{term}}</a>
              </li>
            </template>
          </ul>
				</div>
			</template>


			<template v-else>

				<div class="site-search-results__results-area" :class="{'scrollable':canScroll}" ref="results">
					<template v-if="job_results.length > 0">
						<div class="site-search-results__group" v-if="!filter || filter == 'job'">
							<div class="site-search-results__group-heading"><h4 @click="doFilter('job')">Jobs <span>({{ catTotals.job }})</span></h4></div>
							<div :class="['site-search-job-cards',{'all':!filter}]">
								<template v-for="(result,r) in job_results" :key="`job_${r}`">
									<block-site-search-job-card :result="result.json" @save:search="saveSearch"></block-site-search-job-card>
								</template>
							</div>
              <a class="see-all" :href="`/search/jobs?q=query%253D${$filters.capitalizeFirstLetter(search_term)}`">See all</a>
						</div>
					</template>
					<template v-else>
						<p v-if="filter == 'job'" class="px-4">No results found</p>
					</template>

					<template v-if="org_results.length > 0">
						<div class="site-search-results__group" v-if="!filter || filter == 'organisation'">
							<div class="site-search-results__group-heading"><h4 @click="doFilter('organisation')">Organisations <span>({{ catTotals.organisation }})</span></h4></div>
							<div :class="['site-search-organisation-cards',{'all':!filter}]">
								<template v-for="(result,r) in org_results" :key="`org_${r}`">
									<block-site-search-organisation-card :result="result.json" @save:search="saveSearch"></block-site-search-organisation-card>
								</template>
							</div>
              <a class="see-all" :href="`/search/organisations?q=query%253D${$filters.capitalizeFirstLetter(search_term)}`">See All</a>
						</div>
					</template>
					<template v-else>
						<p v-if="filter == 'organisation'" class="px-4">No results found</p>
					</template>

					<template v-if="event_results.length > 0 || course_results.length > 0">
						<div :class="['site-search-results__group',{'half events':!filter}]" v-if="!filter || filter == 'event'">
							<div class="site-search-results__group-heading"><h4 @click="doFilter('event')">Events <span>({{ catTotals.event }})</span></h4></div>
							<div :class="['site-search-event-cards',{'all':!filter}]">
								<template v-for="(result,r) in event_results" :key="`event_${r}`">
									<block-site-search-event-card :result="result.json" @save:search="saveSearch"></block-site-search-event-card>
								</template>
							</div>
              <a v-if="event_results.length > 0" class="see-all" :href="`/events?q=query%253D${$filters.capitalizeFirstLetter(search_term)}`">See All</a>
						</div>
					</template>
					<template v-else>
						<p v-if="filter == 'event'" class="px-4">No results found</p>
					</template>

					<template v-if="course_results.length > 0 || event_results.length > 0 ">
						<div :class="['site-search-results__group',{'half courses':!filter}]" v-if="!filter || filter == 'course'">
							<div class="site-search-results__group-heading"><h4 @click="doFilter('course')">Courses <span>({{ catTotals.course }})</span></h4></div>
							<div :class="['site-search-course-cards site-search-programme-cards',{'all':!filter}]">
								<template v-for="(result,r) in course_results" :key="`course_${r}`">
                  <template v-if="result.json['prog-or-course'].toLowerCase() === 'course'">
									  <block-site-search-course-card :result="result.json" @save:search="saveSearch"></block-site-search-course-card>
                  </template>
                  <template v-if="result.json['prog-or-course'].toLowerCase() === 'programme'">
                    <block-site-search-programme-card :result="result.json" @save:search="saveSearch"></block-site-search-programme-card>
                  </template>
								</template>
							</div>
              <a v-if="course_results.length > 0" class="see-all" :href="`/courses?q=query%253D${$filters.capitalizeFirstLetter(search_term)}`">See All</a>
						</div>
					</template>
					<template v-else>
						<p v-if="filter == 'course'" class="px-4">No results found</p>
					</template>

					<template v-if="resource_results.length > 0">
						<div class="site-search-results__group" v-if="!filter || filter == 'resources'">
							<div class="site-search-results__group-heading"><h4 @click="doFilter('resources')">Resources <span>({{ catTotals.resources }})</span></h4></div>
							<div :class="['site-search-resource-cards',{'all':!filter}]">
								<template v-for="(result,r) in resource_results" :key="`resource_${r}`">
									<block-site-search-resource-card :result="result.json" @save:search="saveSearch"></block-site-search-resource-card>
								</template>
							</div>
              <a class="see-all" :href="`/resources?q=query%253D${$filters.capitalizeFirstLetter(search_term)}`">See All</a>
						</div>
					</template>
					<template v-else>
						<p v-if="filter == 'resources'" class="px-4">No results found</p>
					</template>

					<template v-if="collection_results.length > 0">
						<div class="site-search-results__group" v-if="!filter || filter == 'collection'">
							<div class="site-search-results__group-heading"><h4 @click="doFilter('collection')">Collections <span>({{ catTotals.collection }})</span></h4></div>
							<div :class="['collection-cards',{'all':!filter}]">
								<template v-for="(result,r) in collection_results" :key="`collection_${r}`">
									<block-site-search-collection-card :result="result.json" @save:search="saveSearch"></block-site-search-collection-card>
								</template>
							</div>
              <a class="see-all" :href="`/search/collections?q=query%253D${$filters.capitalizeFirstLetter(search_term)}`">See All</a>
						</div>
					</template>
					<template v-else>
						<p v-if="filter == 'collection'" class="px-4">No results found</p>
					</template>

					<template v-if="other_results.length > 0">
						<div class="site-search-results__group" v-if="!filter || filter == 'other'">
							<div class="site-search-results__group-heading"><h4>Other <span>({{ catTotals.other }})</span></h4></div>
							<div :class="['other-cards',{'all':!filter}]">
								<template v-for="(result,r) in other_results" :key="`other_${r}`">
									<block-site-search-other-card :result="result.json" @save:search="saveSearch"></block-site-search-other-card>
								</template>
							</div>
						</div>
					</template>
					<template v-else>
						<p v-if="filter == 'other'" class="px-4">No results found</p>
					</template>
				</div>

			</template>
		</div>
	</transition>
</template>

<script>
import algoliasearch from 'algoliasearch';

export default {
	data() {
		return {
			visible: false,
			client: false,
			index: false,
			index_name: (this.$config.test_env) ? 'full-site-dev' : 'full-site-live',
			categories: [
				{'active': true, 'type': 'job', 'label': 'Jobs', 'results':false, 'result_count': 0},
				{'active': true, 'type': 'organisation', 'label': 'Organisations', 'results':false, 'result_count': 0},
				{'active': true, 'type': 'course', 'label': 'Courses', 'results':false, 'result_count': 0},
				{'active': true, 'type': 'event', 'label': 'Events', 'results':false, 'result_count': 0},
				{'active': true, 'type': 'resources', 'label': 'Resources', 'results':false, 'result_count': 0},
				{'active': true, 'type': 'collection', 'label': 'Collections', 'results':false, 'result_count': 0},
				{'active': true, 'type': 'other', 'label': 'Other', 'results':false, 'result_count': 0},
			],
			searchObject: {
				facets: [],
				facetFilters: []
			},
			filter: false,
			search_term: false,
			recent: [], // This needs hooking up to a cookie or local storage.
      catTotals: {},
      canScroll: false,
			escapeYear: 2022
		}
	},

	created() {
		this.escapeYear = document.head.querySelector('meta[name="escape_year"]').content;
    this.recent = this.getRecentCookie().filter(e =>  e);
		this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
		this.index = this.client.initIndex(this.index_name);

		this.emitter.on('site:search',this.performSearch);
	},

	beforeUnmount() {
		this.emitter.off('site:search',this.performSearch);
	},

	methods: {
		performSearch(term) {
			this.visible = true;
			this.search_term = false;

			if (term != null && term.length > 0) {
				var time_now = Date.now();
				var dateFilter = ['valid-until > ' + time_now];//

				var queries = [];
				this.filtered_categories.forEach((cat) => {
					var searchObject = {
						facets: ['type'],
						facetFilters: [["type:"+cat.type], ['publishied:true']], // Note the typo on published //
						numericFilters: [dateFilter]
					}

					var addtional_query = {
						indexName: this.index_name,
						query: term,
						params: searchObject
					}
					queries.push(addtional_query);
				})

				this.client.multipleQueries(queries)
				.then((response) => {

					console.clear();
					console.log("Queries Performed", queries);
					console.log("site wide search raw results:", _.cloneDeep(response));

					this.filtered_categories.forEach((cat,c) => {
            this.catTotals[cat.type] = response.results[c].nbHits;
						cat.results = response.results[c].hits;
						cat.result_count = response.results[c].nbHits;
					});

					this.search_term = term;
				});
			}
		},
		doFilter(type) {
			this.filter = type;
		},
		pickRecentSearch(term) {
			this.emitter.emit("site:search:set",term);
		},
		saveSearch() {
			console.log("Saving recent search: ", this.search_term);
			this.recent.unshift(this.search_term);
			this.setRecentCookie();
		},
		clearRecentSearches() {
			this.recent = [];
			this.setRecentCookie();
		},
		getRecentCookie() {
			let name = "escape_search_history=";
			let decodedCookie = decodeURIComponent(document.cookie);
			let ca = decodedCookie.split(';');
			for(let i = 0; i <ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length).split("|");
				}
			}
			return [];
		},
		setRecentCookie() {
			let value = this.recent.join("|");
			let expiresDays = 365;
			let d = new Date();
			d.setTime(d.getTime() + (expiresDays*24*60*60*1000));
			let expires = "expires=" + d.toGMTString();
			document.cookie = "escape_search_history="+value+";"+expires+";path=/;domain=escapethecity.org";
		}
	},

	computed: {
		filtered_categories() {
			return this.categories.filter((cat) => {
				return cat.active;
			});
		},
		job_results() {
      let category = this.categories.find((cat) => {
				return cat.type == 'job';
			});
			if (!this.filter && category.results) {
				return category.results.slice(0,4);
			}
			return category.results;
		},
		org_results() {
			let category = this.categories.find((cat) => {
				return cat.type == 'organisation';
			});
			if (!this.filter && category.results) {
				return category.results.slice(0,6);
			}
			return category.results;
		},
		event_results() {
			let category = this.categories.find((cat) => {
				return cat.type == 'event';
			});
			if (!this.filter && category.results) {
				return category.results.slice(0,1);
			}
			return category.results;
		},
		course_results() {
			let category = this.categories.find((cat) => {
				return cat.type == 'course';
			});
			if (!this.filter && category.results) {
				return category.results.slice(0,1);
			}
			return category.results;
		},
		resource_results() {
			let category = this.categories.find((cat) => {
				return cat.type == 'resources';
			});
			if (!this.filter && category.results) {
				return category.results.slice(0,3);
			}
			return category.results;
		},
		collection_results() {
			let category = this.categories.find((cat) => {
				return cat.type == 'collection';
			});
			if (!this.filter && category.results) {
				return category.results.slice(0,3);
			}
			return category.results;
		},
		other_results() {
			let category = this.categories.find((cat) => {
				return cat.type == 'other';
			});
			if (!this.filter && category.results) {
				return category.results.slice(0,99);
			}
			return category.results;
		},
		recent_searches() {
			return this.recent.slice(0,3);
		}
	},

  watch: {
    search_term() {
      this.$nextTick(() => {
        let r = this.$refs.results;
        this.canScroll = (r && r.scrollHeight > r.clientHeight) ? true : false;
      });
    }
  }
}

</script>
